import React from 'react'
import PropTypes from 'prop-types'

import BareGradientCard from './BareGradientCard'
import BareStackedCard from './BareStackedCard'
import InterstitialCard from './InterstitialCard'
import YoutubeChromeCard from './YoutubeChromeCard'
import ShortsChromeCard from './ShortsChromeCard'
import GmailChromeCard from './GmailChromeCard'
import NativeArticleCard from './NativeArticleCard'
import DemandGenCarouselCard from './DemandGenCarouselCard'

// Dispatches a Google Display "ad" (see domain/adPreview/googleDisplayVariations.js)
// to its skin component by the `skin` tag the variations builder assigned it.
const SKIN_COMPONENTS = {
  'bare-gradient': BareGradientCard,
  'bare-stacked': BareStackedCard,
  interstitial: InterstitialCard,
  'youtube-chrome': YoutubeChromeCard,
  'shorts-chrome': ShortsChromeCard,
  'gmail-chrome': GmailChromeCard,
  'native-article': NativeArticleCard,
  'demand-gen-carousel': DemandGenCarouselCard,
}

const DisplayAdCard = ({ ad }) => {
  const SkinComponent = SKIN_COMPONENTS[ad.skin] ?? BareStackedCard
  return <SkinComponent ad={ad} />
}

DisplayAdCard.propTypes = {
  ad: PropTypes.shape({
    skin: PropTypes.oneOf(Object.keys(SKIN_COMPONENTS)),
  }).isRequired,
}

export default DisplayAdCard
